import { useFormikContext } from 'formik';
import { get } from 'lodash';

import { Box } from '@hivebrite/design-system/Box';

import {
  Select,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

const ShippingAddressForm = ({
  userFieldsConfig = {},
  withHeading = false,
}) => {
  const { values } = useFormikContext<{
    address_type: string;
  }>();

  const addressType = values?.address_type || 'personal';

  const getPostalPlaceholder = (addressType, field) =>
    get(userFieldsConfig, `postal_${addressType}_${field}_placeholder`);

  return (
    <Box
      data-testid="shipping-address-form"
      display="grid"
      gridTemplateColumns="1fr 1fr"
      style={{ gap: '24px' }}
    >
      {withHeading && (
        <Box font="h4-semibold" gridColumn="1/3">
          {s__('NetworkEvents|Enter shipping address details')}:
        </Box>
      )}

      <Text
        id="receipt[shipping_address_attributes][full_name]"
        name="receipt[shipping_address_attributes][full_name]"
        label={s__('NetworkEvents|Full name')}
        placeholder={s__('NetworkEvents|Full name')}
        validate={{ required: true }}
        wrapperProps={{ mb: 0 }}
      />

      <Text
        id="receipt[shipping_address_attributes][address_1]"
        name="receipt[shipping_address_attributes][address_1]"
        label={I18n.t('web.networks.events.receipt.billing_location.address_1')}
        placeholder={
          getPostalPlaceholder(addressType, 'address_1') ||
          I18n.t('web.networks.events.receipt.billing_location.address_1')
        }
        validate={{ required: true }}
        wrapperProps={{ mb: 0 }}
      />
      <Text
        id="receipt[shipping_address_attributes][address_2]"
        name="receipt[shipping_address_attributes][address_2]"
        label={I18n.t('web.networks.events.receipt.billing_location.address_2')}
        placeholder={
          getPostalPlaceholder(addressType, 'address_2') ||
          I18n.t('web.networks.events.receipt.billing_location.address_2')
        }
        wrapperProps={{ mb: 0 }}
      />
      <Text
        id="receipt[shipping_address_attributes][address_3]"
        name="receipt[shipping_address_attributes][address_3]"
        label={I18n.t('web.networks.events.receipt.billing_location.address_3')}
        placeholder={
          getPostalPlaceholder(addressType, 'address_3') ||
          I18n.t('web.networks.events.receipt.billing_location.address_3')
        }
        wrapperProps={{ mb: 0 }}
      />
      <Text
        id="receipt[shipping_address_attributes][city]"
        name="receipt[shipping_address_attributes][city]"
        placeholder={s__('NetworkEvents|City')}
        label={s__('NetworkEvents|City')}
        validate={{ required: true }}
        wrapperProps={{ mb: 0 }}
      />
      <Text
        id="receipt[shipping_address_attributes][state]"
        name="receipt[shipping_address_attributes][state]"
        placeholder={s__('NetworkEvents|State')}
        label={s__('NetworkEvents|State')}
        wrapperProps={{ mb: 0 }}
      />
      <Text
        id="receipt[shipping_address_attributes][postal_code]"
        name="receipt[shipping_address_attributes][postal_code]"
        placeholder={s__('NetworkEvents|Postal code')}
        label={s__('NetworkEvents|Postal code')}
        validate={{ required: true }}
        wrapperProps={{ mb: 0 }}
      />

      <Select
        type="countries"
        name="receipt[shipping_address_attributes][country]"
        placeholder={I18n.t(
          'web.networks.events.receipt.billing_location.country',
        )}
        label={I18n.t('web.networks.events.receipt.billing_location.country')}
        inputHtml={{
          maxMenuHeight: 160,
        }}
        validate={{ required: true }}
        wrapperProps={{ mb: 0 }}
      />
    </Box>
  );
};

export default ShippingAddressForm;
